// Closed union of context-gate keys for the `dependsOnContext` Contentful
// field on `featureItemAlpha` / `featureItemBravo`. Each value names a
// runtime condition (subject state, session state, cart state, etc.) that
// gates whether a feature item is eligible to render via
// `getAvailableFeatureItemsByDependencies`.
//
// The Contentful field is a free-form string dropdown with human-readable
// labels (e.g., "Senior Portfolio Delivered"); `normalizeContextLabel`
// converts those to the machine format below before comparison.
// Each member's VALUE is the machine-format key produced by
// `normalizeContextLabel` from the Contentful dropdown label — a serialization
// contract with the CMS, so the string values must not change casually.
export enum ContextKey {
  SeniorPortfolioDelivered = 'senior-portfolio-delivered',
  // Senior Preorder marketing-entry contexts. Authored on `heroFeatureItems`
  // via `dependsOnContext` (labels "Senior Preorder Active" / "… Ended" /
  // "… Prepaid"); the resolved context is fed into the gate by `PreorderView`.
  // See `lib/seniorPreorder.ts` (`seniorPreorderContextKey`).
  SeniorPreorderActive = 'senior-preorder-active',
  SeniorPreorderEnded = 'senior-preorder-ended',
  SeniorPreorderPrepaid = 'senior-preorder-prepaid',
  // Sentinel gate — feature items keyed on this render ONLY when no other items
  // survive the filter. See `getAvailableFeatureItemsByDependencies` for the
  // post-step that enforces the fallback semantics.
  Fallback = 'fallback'
}

export const FALLBACK_CONTEXT_KEY: ContextKey = ContextKey.Fallback

// Normalizes a Contentful dropdown label to the machine-format key:
// trims whitespace, lowercases, replaces inner whitespace with hyphens.
// "Senior Portfolio Delivered" → "senior-portfolio-delivered"
export function normalizeContextLabel(label: string): string {
  return label.trim().toLowerCase().replace(/\s+/g, '-')
}
